import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { sideBarItems } from "../../utils";
import { toast } from "react-hot-toast";
import AdminService from "../../services/admin/AdminService";
import SubscriptionService from "../../services/admin/SubscriptionService";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import { Pagination } from "../../components/common/pagination";
import { withRouter } from "react-router-dom";

function SubscriptionDriverControl(props) {
  const { history } = props;
  const assignedPersonStorageKey = "subscriptionDriverAssignedPersonNames";
  const [drivers, setDrivers] = useState([]);
  const [driverPlanMap, setDriverPlanMap] = useState({});
  const [whatsappDrafts, setWhatsappDrafts] = useState({});
  const [assignedPersonNames, setAssignedPersonNames] = useState([]);
  const [assignedPersonDraft, setAssignedPersonDraft] = useState("");
  const [assignedPersonModalOpen, setAssignedPersonModalOpen] = useState(false);
  const [assignedPersonFilter, setAssignedPersonFilter] = useState("all");
  const [packs, setPacks] = useState([]);
  const [search, setSearch] = useState("");
  const [accessFilter, setAccessFilter] = useState("all");
  const [planFilter, setPlanFilter] = useState("all");
  const [verifiedFilter, setVerifiedFilter] = useState("all");
  const [bannedFilter, setBannedFilter] = useState("all");
  const [vehicleFilter, setVehicleFilter] = useState("all");
  const [vehicleTypeFilter, setVehicleTypeFilter] = useState("all");
  const [vehicleVerificationFilter, setVehicleVerificationFilter] =
    useState("all");
  const [createdStartDate, setCreatedStartDate] = useState("");
  const [createdEndDate, setCreatedEndDate] = useState("");
  const [actionLoading, setActionLoading] = useState({});
  const [deactivateConfirmOpen, setDeactivateConfirmOpen] = useState(false);
  const [deactivateDriverId, setDeactivateDriverId] = useState("");
  const [deactivateActionType, setDeactivateActionType] =
    useState("deactivate");
  const [deactivationReason, setDeactivationReason] = useState("");
  const [activateModal, setActivateModal] = useState({
    open: false,
    driver: null,
  });
  const [manualSearchOpen, setManualSearchOpen] = useState(false);
  const [manualSearchNumber, setManualSearchNumber] = useState("");
  const [manualSearchLoading, setManualSearchLoading] = useState(false);
  const [manualSearchResults, setManualSearchResults] = useState([]);
  const [selectedActivationType, setSelectedActivationType] = useState("pack");
  const [selectedPackId, setSelectedPackId] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    try {
      const savedNames = JSON.parse(
        localStorage.getItem(assignedPersonStorageKey) || "[]",
      );
      setAssignedPersonNames(Array.isArray(savedNames) ? savedNames : []);
      setAssignedPersonDraft(
        Array.isArray(savedNames) ? savedNames.join("\n") : "",
      );
    } catch (err) {
      setAssignedPersonNames([]);
      setAssignedPersonDraft("");
    }
    loadPacks();
  }, []);

  useEffect(() => {
    loadDriverPage();
  }, [
    page,
    limit,
    search,
    assignedPersonFilter,
    accessFilter,
    planFilter,
    verifiedFilter,
    bannedFilter,
    vehicleFilter,
    vehicleTypeFilter,
    vehicleVerificationFilter,
    createdStartDate,
    createdEndDate,
  ]);

  const chunkArray = (items = [], size = 100) => {
    if (!Array.isArray(items) || size <= 0) {
      return [];
    }
    const chunks = [];
    for (let index = 0; index < items.length; index += size) {
      chunks.push(items.slice(index, index + size));
    }
    return chunks;
  };

  const getError = (err) => {
    const error = err?.response?.data?.error;
    if (typeof error === "string") {
      return error;
    }
    return (
      error?.message ||
      err?.response?.data?.message ||
      err?.message ||
      "Operation failed"
    );
  };

  const parseDrivers = (response) => {
    const users = response?.data?.users;
    if (Array.isArray(users)) {
      return users;
    }

    const owners = response?.data?.owners;
    if (Array.isArray(owners)) {
      return owners;
    }

    if (Array.isArray(response?.data)) {
      return response.data;
    }

    return [];
  };

  const buildServerFilter = () => {
    const filter = {};
    const setBooleanFilter = (key, value) => {
      if (value !== "all") {
        filter[key] = value === "yes" || value === "enabled" || value === "verified";
      }
    };
    const query = String(search || "").trim();
    if (query) {
      filter.searchText = query;
    }
    if (assignedPersonFilter !== "all") {
      filter.assignedPersonName = assignedPersonFilter;
    }
    if (accessFilter !== "all") {
      filter.subscriptionAccessStatus = accessFilter;
    }
    if (planFilter !== "all") {
      filter.subscriptionPlanStatus = planFilter;
    }
    if (vehicleFilter !== "all") {
      filter.hasVehicle = vehicleFilter;
    }
    if (vehicleTypeFilter !== "all") {
      filter.vehicleType = vehicleTypeFilter;
    }
    if (vehicleVerificationFilter !== "all") {
      filter.vehicleVerificationStatus = vehicleVerificationFilter;
    }
    if (createdStartDate) {
      filter.createdStartDate = createdStartDate;
    }
    if (createdEndDate) {
      filter.createdEndDate = createdEndDate;
    }
    setBooleanFilter("isVerifiedAsDriver", verifiedFilter);
    setBooleanFilter("isBanned", bannedFilter);
    filter.rideShareOnly = true;
    return filter;
  };

  const loadPacks = async () => {
    try {
      const packRes = await SubscriptionService.getPacks();
      const packList =
        packRes?.data?.packs || packRes?.data?.data || packRes?.data || [];
      setPacks(Array.isArray(packList) ? packList : []);
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const loadDriverPage = async () => {
    try {
      const driverRes = await AdminService.getOwnersPg(
        page,
        limit,
        buildServerFilter(),
      );
      const driverList = parseDrivers(driverRes);
      setDrivers(driverList);
      setAssignedPersonNames((prev) => {
        const mergedNames = [
          ...prev,
          ...driverList
            .map((driver) => driver?.assignedPersonName)
            .filter(Boolean),
        ];
        return Array.from(new Set(mergedNames));
      });
      setWhatsappDrafts(
        driverList.reduce((drafts, driver) => {
          if (driver?._id) {
            drafts[driver._id] = driver?.whatsappNo || "";
          }
          return drafts;
        }, {}),
      );

      const total = Number(
        driverRes?.data?.totalUsers || driverList.length || 0,
      );
      const pages = Number(
        driverRes?.data?.totalPages || Math.max(1, Math.ceil(total / limit)),
      );
      setTotalUsers(total);
      setTotalPages(pages > 0 ? pages : 1);

      const driverIds = driverList.map((d) => d?._id).filter(Boolean);
      if (driverIds.length) {
        const mergedStatusMap = {};
        const idChunks = chunkArray(driverIds, 100);
        for (const idChunk of idChunks) {
          const statusRes =
            await SubscriptionService.getDriversSubscriptionStatus(idChunk);
          Object.assign(mergedStatusMap, statusRes?.data?.data || {});
        }
        setDriverPlanMap(mergedStatusMap);
      } else {
        setDriverPlanMap({});
      }
    } catch (err) {
      toast.error(getError(err));
      setDrivers([]);
      setDriverPlanMap({});
      setTotalUsers(0);
      setTotalPages(1);
    }
  };

  const init = async () => {
    await loadDriverPage();
  };

  const setRowLoading = (driverId, key, value) => {
    const stateKey = `${driverId}:${key}`;
    setActionLoading((prev) => ({
      ...prev,
      [stateKey]: value,
    }));
  };

  const isRowLoading = (driverId, key) => !!actionLoading[`${driverId}:${key}`];

  const getVehicleSummary = (driver) => {
    const vehicles = (driver?.vehicles || []).filter(({ vehicle }) => {
      return vehicle && vehicle.deleted !== true;
    });

    return {
      total: vehicles.length,
      verified: vehicles.filter(({ vehicle }) => {
        return vehicle?.verifiedStatus === "verified";
      }).length,
      unverified: vehicles.filter(({ vehicle }) => {
        return vehicle?.verifiedStatus !== "verified";
      }).length,
    };
  };

  const getLookupHistory = (driver) => driver?.subscriptionHistory || {};

  useEffect(() => {
    setPage(1);
  }, [
    search,
    assignedPersonFilter,
    accessFilter,
    planFilter,
    verifiedFilter,
    bannedFilter,
    vehicleFilter,
    vehicleTypeFilter,
    vehicleVerificationFilter,
    createdStartDate,
    createdEndDate,
  ]);

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const nextPage = () => {
    setPage((prev) => (prev < totalPages ? prev + 1 : prev));
  };

  const prevPage = () => {
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleToggleTrial = async (driver) => {
    const driverId = driver?._id;
    if (!driverId) return;
    setRowLoading(driverId, "trial", true);
    try {
      await SubscriptionService.toggleTrial(driverId, {
        enabled: !driver.trialEnabled,
      });
      toast.success("Subscription eligibility updated successfully");
      await init();
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setRowLoading(driverId, "trial", false);
    }
  };

  const handleSaveWhatsappNo = async (driver) => {
    const driverId = driver?._id;
    if (!driverId) return;

    const whatsappNo = String(whatsappDrafts[driverId] || "").trim();
    if (!/^\d{11}$/.test(whatsappNo)) {
      toast.error("Whatsapp number must be 11 digits");
      return;
    }

    setRowLoading(driverId, "whatsapp", true);
    try {
      await AdminService.updateProfile(driverId, { whatsappNo });
      setDrivers((prev) =>
        prev.map((item) =>
          item?._id === driverId ? { ...item, whatsappNo } : item,
        ),
      );
      toast.success("Whatsapp number saved");
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setRowLoading(driverId, "whatsapp", false);
    }
  };

  const handleSaveAssignedPersonNames = () => {
    const names = assignedPersonDraft
      .split("\n")
      .map((name) => name.trim())
      .filter(Boolean);
    const uniqueNames = Array.from(new Set(names));
    localStorage.setItem(assignedPersonStorageKey, JSON.stringify(uniqueNames));
    setAssignedPersonNames(uniqueNames);
    setAssignedPersonDraft(uniqueNames.join("\n"));
    setAssignedPersonModalOpen(false);
    toast.success("Assigned person names saved");
  };

  const handleAssignedPersonChange = async (driver, assignedPersonName) => {
    const driverId = driver?._id;
    if (!driverId) return;

    setRowLoading(driverId, "assignedPerson", true);
    try {
      await AdminService.updateProfile(driverId, { assignedPersonName });
      setDrivers((prev) =>
        prev.map((item) =>
          item?._id === driverId ? { ...item, assignedPersonName } : item,
        ),
      );
      toast.success("Assigned person saved");
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setRowLoading(driverId, "assignedPerson", false);
    }
  };

  const openActivateModal = (driver) => {
    setActivateModal({ open: true, driver });
    setSelectedActivationType("pack");
    setSelectedPackId("");
  };

  const openManualSearchModal = () => {
    setManualSearchOpen(true);
    setManualSearchNumber("");
    setManualSearchResults([]);
  };

  const closeManualSearchModal = () => {
    setManualSearchOpen(false);
    setManualSearchNumber("");
    setManualSearchResults([]);
    setManualSearchLoading(false);
  };

  const handleManualDriverSearch = async () => {
    const query = String(manualSearchNumber || "").trim();
    if (!query) {
      toast.error("Please enter a mobile number");
      return;
    }

    setManualSearchLoading(true);
    try {
      const response = await SubscriptionService.lookupDriver(query);
      const resultList = response?.data?.data || [];
      setManualSearchResults(resultList);
      if (!resultList.length) {
        toast.error("No owner found with this number");
      }
    } catch (err) {
      toast.error(getError(err));
      setManualSearchResults([]);
    } finally {
      setManualSearchLoading(false);
    }
  };

  const selectManualSearchDriver = (driver) => {
    setActivateModal({ open: true, driver });
    setSelectedActivationType("trial");
    setSelectedPackId("");
    closeManualSearchModal();
  };

  const handleManualActivate = async () => {
    const driverId = activateModal?.driver?._id;
    if (!driverId) {
      toast.error("Driver not selected");
      return;
    }
    if (selectedActivationType === "pack" && !selectedPackId) {
      toast.error("Please select a pack");
      return;
    }
    setRowLoading(driverId, "activate", true);
    try {
      if (selectedActivationType === "trial") {
        await SubscriptionService.activateFreeTrial(driverId);
      } else {
        await SubscriptionService.activateSubscription({
          driverId,
          type: "pack",
          packId: selectedPackId,
        });
      }
      toast.success("Subscription activated successfully");
      setActivateModal({ open: false, driver: null });
      setSelectedActivationType("pack");
      setSelectedPackId("");
      await init();
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setRowLoading(driverId, "activate", false);
    }
  };

  const handleDeactivate = async () => {
    if (!deactivateDriverId) {
      toast.error("Please select a driver");
      setDeactivateConfirmOpen(false);
      return;
    }
    setRowLoading(deactivateDriverId, "deactivate", true);
    try {
      if (deactivateActionType === "activate") {
        await SubscriptionService.activateDriver(deactivateDriverId);
        toast.success("Driver activated successfully");
      } else if (deactivateActionType === "pause") {
        await SubscriptionService.pauseDriver(deactivateDriverId, {
          reason: String(deactivationReason || "").trim() || undefined,
        });
        toast.success("Subscription paused successfully");
      } else {
        await SubscriptionService.deactivateDriver(deactivateDriverId, {
          reason: String(deactivationReason || "").trim() || undefined,
        });
        toast.success("Driver deactivated successfully");
      }
      setDeactivateConfirmOpen(false);
      setDeactivateDriverId("");
      setDeactivateActionType("deactivate");
      setDeactivationReason("");
      await init();
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setRowLoading(deactivateDriverId, "deactivate", false);
    }
  };

  const handleDeactivateClick = (driverId, actionType = "deactivate") => {
    setDeactivateDriverId(driverId || "");
    setDeactivateActionType(actionType);
    if (actionType !== "deactivate") {
      setDeactivationReason("");
    }
    setDeactivateConfirmOpen(true);
  };

  const goToDriverDetail = (driverId, section) => {
    if (!driverId) return;
    if (section === "bids") {
      history.push(`/ridesharebids/driver/${driverId}`);
      return;
    }
    history.push(`/subscriptiondriver/${driverId}/${section}`);
  };

  return (
    <Layout title={sideBarItems.subscriptionDriver.key}>
      <div
        className="w-full min-w-0 py-6 overflow-x-hidden"
        style={{ overflowX: "clip" }}
      >
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          Driver Subscription Control
        </h1>
        <div className="flex justify-end gap-2 mb-4">
          <button
            className="px-4 py-2 rounded-md bg-green-600 text-white text-sm font-semibold hover:bg-green-700"
            onClick={openManualSearchModal}
          >
            Find Driver & Activate
          </button>
          <button
            className="px-4 py-2 rounded-md bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700"
            onClick={() => setAssignedPersonModalOpen(true)}
          >
            Save Assigned Person Names
          </button>
        </div>

        <div
          className="bg-white shadow-md rounded-lg p-6 min-w-0 max-w-full overflow-x-hidden"
          style={{ overflowX: "clip" }}
        >
          <div className="flex flex-col gap-3 mb-4">
            <h2 className="text-lg font-semibold">Drivers</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-6 gap-2 w-full">
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Search
                <input
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  placeholder="Name, mobile, WhatsApp or driver ID"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Assigned Person
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={assignedPersonFilter}
                  onChange={(e) => setAssignedPersonFilter(e.target.value)}
                >
                  <option value="all">All Assigned</option>
                  {assignedPersonNames.map((name) => (
                    <option key={name} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Current Plan
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={planFilter}
                  onChange={(e) => setPlanFilter(e.target.value)}
                >
                  <option value="all">All Plans</option>
                  <option value="active">Has Active Plan</option>
                  <option value="none">No Active Plan</option>
                  <option value="trial">Trial</option>
                  <option value="manual">Manual</option>
                  <option value="paid">Paid</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Access
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={accessFilter}
                  onChange={(e) => setAccessFilter(e.target.value)}
                >
                  <option value="all">All Access</option>
                  <option value="active">Active</option>
                  <option value="frozen">Frozen</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Vehicle
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={vehicleFilter}
                  onChange={(e) => setVehicleFilter(e.target.value)}
                >
                  <option value="all">All Vehicles</option>
                  <option value="yes">Has Vehicle</option>
                  <option value="no">No Vehicle</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Vehicle Type
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={vehicleTypeFilter}
                  onChange={(e) => setVehicleTypeFilter(e.target.value)}
                >
                  <option value="all">All Vehicle Types</option>
                  <option value="Sedan">Sedan</option>
                  <option value="Micro">Micro</option>
                  <option value="Private Car">Private Car</option>
                  <option value="CNG">CNG</option>
                  <option value="Bike">Bike</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Vehicle Verification
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={vehicleVerificationFilter}
                  onChange={(e) => setVehicleVerificationFilter(e.target.value)}
                >
                  <option value="all">All Vehicle Status</option>
                  <option value="pending">Has Pending Vehicle</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Driver Verified
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={verifiedFilter}
                  onChange={(e) => setVerifiedFilter(e.target.value)}
                >
                  <option value="all">All Verification</option>
                  <option value="yes">Verified</option>
                  <option value="no">Not Verified</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Banned
                <select
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  value={bannedFilter}
                  onChange={(e) => setBannedFilter(e.target.value)}
                >
                  <option value="all">All Ban Status</option>
                  <option value="yes">Banned</option>
                  <option value="no">Not Banned</option>
                </select>
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Created From
                <input
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  type="date"
                  value={createdStartDate}
                  onChange={(e) => setCreatedStartDate(e.target.value)}
                />
              </label>
              <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
                Created To
                <input
                  className="w-full px-3 py-2 border rounded-md text-sm font-normal text-gray-900"
                  type="date"
                  value={createdEndDate}
                  onChange={(e) => setCreatedEndDate(e.target.value)}
                />
              </label>
              <button
                className="self-end px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                onClick={() => {
                  setSearch("");
                  setAssignedPersonFilter("all");
                  setAccessFilter("all");
                  setPlanFilter("all");
                  setVerifiedFilter("all");
                  setBannedFilter("all");
                  setVehicleFilter("all");
                  setVehicleTypeFilter("all");
                  setVehicleVerificationFilter("all");
                  setCreatedStartDate("");
                  setCreatedEndDate("");
                }}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="w-full min-w-0 max-w-full overflow-x-auto overscroll-x-contain">
            <table className="min-w-full border border-gray-200">
              <thead>
                <tr className="bg-gray-50 text-left text-sm text-gray-600">
                  <th className="px-4 py-2 border">Driver ID</th>
                  <th className="px-4 py-2 border">Name</th>
                  <th className="px-4 py-2 border">Mobile</th>
                  <th className="px-4 py-2 border">Whatsapp no.</th>
                  <th className="px-4 py-2 border">Assigned Person</th>
                  <th className="px-4 py-2 border">Current Plan</th>
                  <th className="px-4 py-2 border">Trial Eligibility</th>
                  <th className="px-4 py-2 border">Vehicles</th>
                  <th className="px-4 py-2 border">Vehicle List</th>
                  <th className="px-4 py-2 border">Add Subscription</th>
                  <th className="px-4 py-2 border">Income Statement</th>
                  <th className="px-4 py-2 border">Payments</th>
                  <th className="px-4 py-2 border">Personal Data</th>
                  <th className="px-4 py-2 border">Ride Share Bids</th>
                  <th className="px-4 py-2 border">Pause Subscription</th>
                  <th className="px-4 py-2 border">Pause Reason</th>
                  <th className="px-4 py-2 border">Deactivate</th>
                  <th className="px-4 py-2 border">Deactivate Reason</th>
                </tr>
              </thead>
              <tbody>
                {drivers.map((driver) => {
                  const vehicleSummary = getVehicleSummary(driver);

                  return (
                    <tr key={driver._id} className="text-sm">
                    <td className="px-4 py-2 border">{driver._id}</td>
                    <td className="px-4 py-2 border">{driver.name || "N/A"}</td>
                    <td className="px-4 py-2 border">
                      {driver.mobile || "N/A"}
                    </td>
                    <td className="px-4 py-2 border">
                      <div className="flex flex-col items-start gap-2 min-w-[160px]">
                        <input
                          className="w-36 px-2 py-1 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          value={whatsappDrafts[driver._id] || ""}
                          onChange={(e) =>
                            setWhatsappDrafts((prev) => ({
                              ...prev,
                              [driver._id]: e.target.value.replace(/\D/g, "").slice(0, 11),
                            }))
                          }
                          placeholder="01XXXXXXXXX"
                        />
                        {(whatsappDrafts[driver._id] || "") !==
                          (driver?.whatsappNo || "") && (
                          <button
                            className="px-3 py-1 text-sm font-semibold rounded-md bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50"
                            onClick={() => handleSaveWhatsappNo(driver)}
                            disabled={isRowLoading(driver._id, "whatsapp")}
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-2 border">
                      <select
                        className="min-w-[160px] px-2 py-1 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50"
                        value={driver?.assignedPersonName || ""}
                        onChange={(e) =>
                          handleAssignedPersonChange(driver, e.target.value)
                        }
                        disabled={isRowLoading(driver._id, "assignedPerson")}
                      >
                        <option value="">Unassigned</option>
                        {assignedPersonNames.map((name) => (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="px-4 py-2 border">
                      <div>
                        {driverPlanMap?.[driver._id]?.planLabel ||
                          "No Active Subscription"}
                      </div>
                      {driverPlanMap?.[driver._id]?.expiryDate && (
                        <div className="text-xs text-gray-500">
                          Expires:{" "}
                          {new Date(
                            driverPlanMap[driver._id].expiryDate,
                          ).toLocaleDateString()}
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        onClick={() => handleToggleTrial(driver)}
                        disabled={isRowLoading(driver._id, "trial")}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${driver.trialEnabled ? "bg-indigo-600" : "bg-gray-300"} ${isRowLoading(driver._id, "trial") ? "opacity-50 cursor-not-allowed" : ""}`}
                        type="button"
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${driver.trialEnabled ? "translate-x-6" : "translate-x-1"}`}
                        />
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <div className="flex flex-col gap-1 min-w-[120px] items-start">
                        <span
                          className={`inline-flex items-center justify-center rounded-full px-2 py-1 text-xs font-semibold whitespace-nowrap ${
                            vehicleSummary.total > 0
                              ? "bg-blue-100 text-blue-800"
                              : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          Total: {vehicleSummary.total}
                        </span>
                        {vehicleSummary.verified > 0 && (
                          <span className="inline-flex items-center justify-center rounded-full px-2 py-1 text-xs font-semibold whitespace-nowrap bg-green-100 text-green-800">
                            Verified: {vehicleSummary.verified}
                          </span>
                        )}
                        {vehicleSummary.unverified > 0 && (
                          <span className="inline-flex items-center justify-center rounded-full px-2 py-1 text-xs font-semibold whitespace-nowrap bg-red-100 text-red-800">
                            Pending: {vehicleSummary.unverified}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-yellow-500 hover:bg-yellow-600 shadow-sm"
                        style={{ minWidth: "96px" }}
                        onClick={() => goToDriverDetail(driver._id, "vehicles")}
                      >
                        Vehicles
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 shadow-sm disabled:opacity-50"
                        style={{ minWidth: "96px" }}
                        onClick={() => openActivateModal(driver)}
                        disabled={isRowLoading(driver._id, "activate")}
                      >
                        Add Subscription
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 shadow-sm"
                        style={{ minWidth: "96px" }}
                        onClick={() => goToDriverDetail(driver._id, "income")}
                      >
                        Income
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm whitespace-nowrap"
                        style={{ minWidth: "96px", backgroundColor: "#0f766e" }}
                        onClick={() => goToDriverDetail(driver._id, "payments")}
                      >
                        Payments
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 shadow-sm"
                        style={{ minWidth: "96px" }}
                        onClick={() => goToDriverDetail(driver._id, "personal")}
                      >
                        Personal
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-gray-700 hover:bg-black shadow-sm"
                        style={{ minWidth: "96px" }}
                        onClick={() => goToDriverDetail(driver._id, "bids")}
                      >
                        Bids
                      </button>
                    </td>
                    <td className="px-4 py-2 border">
                      {driver.subscriptionFreezeReason === "admin_paused" ? (
                        <button
                          className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 shadow-sm disabled:opacity-50"
                          style={{
                            minWidth: "96px",
                            backgroundColor: "#16a34a",
                            color: "#ffffff",
                            border: "1px solid #15803d",
                          }}
                          onClick={() =>
                            handleDeactivateClick(driver._id, "activate")
                          }
                          disabled={isRowLoading(driver._id, "deactivate")}
                        >
                          Resume
                        </button>
                      ) : (
                        <button
                          className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-amber-600 hover:bg-amber-700 shadow-sm disabled:opacity-50"
                          style={{
                            minWidth: "96px",
                            backgroundColor: "#d97706",
                            color: "#ffffff",
                            border: "1px solid #b45309",
                          }}
                          onClick={() =>
                            handleDeactivateClick(driver._id, "pause")
                          }
                          disabled={isRowLoading(driver._id, "deactivate")}
                        >
                          Pause
                        </button>
                      )}
                    </td>
                    <td className="px-4 py-2 border">
                      <div className="text-sm text-gray-700 whitespace-pre-wrap break-words">
                        {driver?.subscriptionPauseReason || "N/A"}
                      </div>
                    </td>
                    <td className="px-4 py-2 border">
                      {driver.subscriptionAccessStatus === "frozen" ? (
                        <button
                          className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 shadow-sm disabled:opacity-50"
                          style={{ minWidth: "96px" }}
                          onClick={() =>
                            handleDeactivateClick(driver._id, "activate")
                          }
                          disabled={isRowLoading(driver._id, "deactivate")}
                        >
                          Activate
                        </button>
                      ) : (
                        <button
                          className="inline-flex items-center justify-center min-w-[96px] rounded-md px-3 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 shadow-sm disabled:opacity-50"
                          style={{ minWidth: "96px" }}
                          onClick={() =>
                            handleDeactivateClick(driver._id, "deactivate")
                          }
                          disabled={isRowLoading(driver._id, "deactivate")}
                        >
                          Deactivate
                        </button>
                      )}
                    </td>
                    <td className="px-4 py-2 border max-w-[240px]">
                      <div className="text-sm text-gray-700 whitespace-pre-wrap break-words">
                        {driver?.subscriptionDeactivateReason || "N/A"}
                      </div>
                    </td>
                    </tr>
                  );
                })}
                {!drivers.length && (
                  <tr>
	                    <td
	                      colSpan="18"
	                      className="px-4 py-8 text-center text-gray-500"
	                    >
                      No drivers found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalUsers > 0 && (
            <div className="flex justify-center items-center mt-6">
              <Pagination
                page={page}
                totalPages={totalPages}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                prevPage={prevPage}
                nextPage={nextPage}
              />
            </div>
          )}
        </div>
      </div>

      {deactivateActionType === "activate" ? (
        <ConfirmDialog
          isOpen={deactivateConfirmOpen}
          onClose={() => {
            setDeactivateConfirmOpen(false);
            setDeactivateActionType("deactivate");
            setDeactivationReason("");
          }}
          onConfirm={handleDeactivate}
          title="Activate Driver"
          message="Are you sure you want to activate this driver account?"
        />
      ) : null}

      {assignedPersonModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-center justify-center">
          <div className="relative mx-auto p-6 border w-full max-w-lg shadow-2xl rounded-lg bg-white">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold">Assigned Person Names</h3>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={() => setAssignedPersonModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Names
            </label>
            <textarea
              className="w-full border rounded-md px-3 py-2 min-h-[160px] focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={assignedPersonDraft}
              onChange={(e) => setAssignedPersonDraft(e.target.value)}
              placeholder={"One name per line"}
            />
            <div className="mt-5 flex justify-end gap-2">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                onClick={() => setAssignedPersonModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                onClick={handleSaveAssignedPersonNames}
              >
                Save Names
              </button>
            </div>
          </div>
        </div>
      )}

      {deactivateConfirmOpen &&
      (deactivateActionType === "deactivate" ||
        deactivateActionType === "pause") ? (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-center justify-center z-40">
          <div className="relative mx-auto p-6 border w-full max-w-xl shadow-2xl rounded-lg bg-white">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {deactivateActionType === "pause"
                ? "Pause Subscription"
                : "Deactivate Driver"}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              You can optionally provide a reason. This reason will be shown to
              the driver when bidding is blocked.
            </p>

            <label className="block text-sm font-medium text-gray-700 mb-2">
              {deactivateActionType === "pause"
                ? "Pause reason (optional)"
                : "Deactivation reason (optional)"}
            </label>
            <textarea
              className="w-full border rounded-md px-3 py-2 min-h-[100px] focus:outline-none focus:ring-2 focus:ring-indigo-500"
              maxLength={500}
              value={deactivationReason}
              onChange={(e) => setDeactivationReason(e.target.value)}
              placeholder={
                deactivateActionType === "pause"
                  ? "Write reason for pausing subscription"
                  : "Write reason for driver deactivation"
              }
            />

            <div className="mt-5 flex gap-2 justify-end">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                onClick={() => {
                  setDeactivateConfirmOpen(false);
                  setDeactivateActionType("deactivate");
                  setDeactivationReason("");
                }}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white rounded-md"
                style={
                  deactivateActionType === "pause"
                    ? {
                        backgroundColor: "#d97706",
                        border: "1px solid #b45309",
                        color: "#ffffff",
                      }
                    : {
                        backgroundColor: "#dc2626",
                        border: "1px solid #b91c1c",
                        color: "#ffffff",
                      }
                }
                onClick={handleDeactivate}
              >
                {deactivateActionType === "pause" ? "Pause" : "Deactivate"}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {manualSearchOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-center justify-center">
          <div className="relative mx-auto p-6 border w-full max-w-2xl shadow-2xl rounded-lg bg-white">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold">
                Find Driver by Mobile
              </h3>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={closeManualSearchModal}
              >
                <i className="fas fa-times" />
              </button>
            </div>

            <p className="text-sm text-gray-600 mb-4">
              Search from owners by mobile number, then activate a free trial or
              subscription pack.
            </p>

            <div className="flex flex-col md:flex-row gap-2 mb-4">
              <input
                className="flex-1 px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter mobile number"
                value={manualSearchNumber}
                onChange={(e) =>
                  setManualSearchNumber(e.target.value.replace(/[^\d+]/g, ""))
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleManualDriverSearch();
                  }
                }}
              />
              <button
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
                onClick={handleManualDriverSearch}
                disabled={manualSearchLoading}
              >
                {manualSearchLoading ? "Searching..." : "Search"}
              </button>
            </div>

            <div className="border rounded-md overflow-hidden">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 text-left text-gray-600">
                    <th className="px-3 py-2 border">Name</th>
                    <th className="px-3 py-2 border">Mobile</th>
                    <th className="px-3 py-2 border">Driver</th>
                    <th className="px-3 py-2 border">Subscription History</th>
                    <th className="px-3 py-2 border">Free Trial</th>
                    <th className="px-3 py-2 border">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {manualSearchResults.map((driver) => {
                    const history = getLookupHistory(driver);
                    return (
                      <tr key={driver._id}>
                        <td className="px-3 py-2 border">
                          {driver?.name || "N/A"}
                        </td>
                        <td className="px-3 py-2 border">
                          {driver?.mobile || "N/A"}
                        </td>
                        <td className="px-3 py-2 border">
                          {driver?.isDriver ? "Yes" : "No"}
                        </td>
                        <td className="px-3 py-2 border">
                          <div className="text-sm">
                            {history?.hasAnySubscription
                              ? `${history.latestType || "Subscription"} (${history.latestStatus || "unknown"})`
                              : "No previous subscription"}
                          </div>
                          {history?.latestExpiryDate ? (
                            <div className="text-xs text-gray-500">
                              Expires:{" "}
                              {new Date(
                                history.latestExpiryDate,
                              ).toLocaleDateString()}
                            </div>
                          ) : null}
                        </td>
                        <td className="px-3 py-2 border">
                          <span
                            className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
                              history?.freeTrialAllowed
                                ? "bg-green-100 text-green-800"
                                : "bg-amber-100 text-amber-800"
                            }`}
                          >
                            {history?.freeTrialStatus || "N/A"}
                          </span>
                        </td>
                        <td className="px-3 py-2 border">
                          <button
                            className="px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700"
                            onClick={() => selectManualSearchDriver(driver)}
                          >
                            Select
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {!manualSearchResults.length && (
                    <tr>
                      <td
                        colSpan="6"
                        className="px-3 py-6 text-center text-gray-500"
                      >
                        Search by mobile number to find a driver.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {activateModal.open && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-center justify-center z-40">
          <div className="relative mx-auto p-6 border w-full max-w-xl shadow-2xl rounded-lg bg-white">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-semibold">Activate Subscription</h3>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={() => {
                  setActivateModal({ open: false, driver: null });
                  setSelectedActivationType("pack");
                  setSelectedPackId("");
                }}
              >
                <i className="fas fa-times" />
              </button>
            </div>

            <p className="text-sm text-gray-700 mb-3">
              Driver:{" "}
              <span className="font-semibold">
                {activateModal?.driver?.name || "N/A"}
              </span>{" "}
              ({activateModal?.driver?.mobile || "N/A"})
            </p>

            <label className="block text-sm font-medium text-gray-700 mb-2">
              Activation type
            </label>
            <select
              className="w-full px-3 py-2 border rounded-md mb-4"
              value={selectedActivationType}
              onChange={(e) => {
                setSelectedActivationType(e.target.value);
                if (e.target.value === "trial") {
                  setSelectedPackId("");
                }
              }}
            >
              <option value="pack">Subscription pack</option>
              <option value="trial">Free trial</option>
            </select>

            {selectedActivationType === "trial" ? (
              <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
                {getLookupHistory(activateModal?.driver)?.freeTrialStatus ||
                  "Free trial will only activate if this driver has no previous subscription and no previous free trial."}
              </div>
            ) : null}

            {selectedActivationType === "pack" ? (
              <>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select pack
                </label>
                <select
                  className="w-full px-3 py-2 border rounded-md"
                  value={selectedPackId}
                  onChange={(e) => setSelectedPackId(e.target.value)}
                >
                  <option value="">Choose pack</option>
                  {packs.map((pack) => (
                    <option key={pack._id} value={pack._id}>
                      {pack.name} - {pack.durationDays} days - BDT {pack.price}
                    </option>
                  ))}
                </select>
              </>
            ) : null}

            <div className="mt-5 flex gap-2">
              <button
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
                onClick={handleManualActivate}
                disabled={
                  (selectedActivationType === "pack" && !selectedPackId) ||
                  (selectedActivationType === "trial" &&
                    getLookupHistory(activateModal?.driver)
                      ?.freeTrialAllowed === false) ||
                  isRowLoading(activateModal?.driver?._id, "activate")
                }
              >
                {selectedActivationType === "trial"
                  ? "Activate Free Trial"
                  : "Activate"}
              </button>
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                onClick={() => {
                  setActivateModal({ open: false, driver: null });
                  setSelectedActivationType("pack");
                  setSelectedPackId("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default withRouter(SubscriptionDriverControl);
